import companiesCreateComponent from './companies-create.component';

const companiesCreateModule = angular
  .module('companiesModule', [])
  .component('companiesCreate', companiesCreateComponent);

export default companiesCreateModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-create/companies-create.js
 **/